import React, { memo } from "react";
import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import Iconify from "../../components/Iconify";

// Move GradientCard outside to avoid re-creating it on each render
const GradientCard = styled(motion.div)({
  backgroundImage: "linear-gradient(to right, #386150,#58B09C)",
  // background: `linear-gradient(135deg,rgba(0, 139, 208, 0.79),rgba(160, 37, 194, 0.74))`,
  padding: "20px",
  borderRadius: "12px",
  cursor: "pointer",
  display: "flex",
  position: "relative",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "6px 6px 4px 0 black",
  },
});

const SrtDashboardCard = memo(
  ({ name, rescheduledCount, popups, navigatebuttons }) => {
    return (
      <GradientCard
        initial={{ y: -200, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
            gap: "5px",
            mb: 2,
            height: "auto",
          }}
        >
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 700,
              color: "#fff",
              textTransform: "uppercase",
            }}
          >
            {name}
          </Typography>
          <Iconify
            icon={"material-symbols:school-rounded"}
            color="#fff"
            width={40}
            height={40}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: "10px",
            right: "10px",
            borderRadius: "15px",
            height: "auto",
            width: "auto",
            p: 1,
            background: "white",
          }}
        >
          <Typography sx={{ color: "#386150", fontSize: 18, fontWeight: 700 }}>
            {rescheduledCount}
          </Typography>
        </Box>
        {popups}
        {navigatebuttons}
      </GradientCard>
    );
  }
);

export default SrtDashboardCard;
